document.addEventListener('DOMContentLoaded', function () {

  /* ── メールアドレス確認 ── */
  const emailInput   = document.getElementById('contact_email');
  const confirmInput = document.getElementById('contact_email_confirm');
  const matchMsg     = document.getElementById('email-match-msg');

  function checkEmailMatch() {
    if (confirmInput.value === '') {
      matchMsg.textContent = '';
      matchMsg.className   = 'field-note';
      return;
    }
    if (emailInput.value === confirmInput.value) {
      matchMsg.textContent = '✓ メールアドレスが一致しています';
      matchMsg.className   = 'field-note match-ok';
    } else {
      matchMsg.textContent = '✗ メールアドレスが一致していません';
      matchMsg.className   = 'field-note match-ng';
    }
  }

  if (emailInput && confirmInput) {
    emailInput.addEventListener('input', checkEmailMatch);
    confirmInput.addEventListener('input', checkEmailMatch);
  }

  /* フォーム送信時にも確認 */
  const form = document.querySelector('form[action*="/contact"]');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (emailInput && confirmInput && emailInput.value !== confirmInput.value) {
        e.preventDefault();
        matchMsg.textContent = '✗ メールアドレスが一致していません。確認してください。';
        matchMsg.className   = 'field-note match-ng';
        confirmInput.focus();
      }
    });
  }

  /* ── 郵便番号自動入力 (zipcloud) ── */
  const zipInput  = document.getElementById('contact_zip');
  const zipBtn    = document.getElementById('zip-search-btn');
  const zipMsg    = document.getElementById('zip-msg');
  const addrInput = document.getElementById('contact_address');

  if (zipBtn) {
    zipBtn.addEventListener('click', function () {
      if (!zipInput) return;

      const raw    = zipInput.value.replace(/[^0-9]/g, '');
      if (raw.length !== 7) {
        zipMsg.textContent = '7桁の数字で郵便番号を入力してください（例：1234567）';
        zipMsg.className   = 'field-note match-ng';
        return;
      }

      zipMsg.textContent = '検索中…';
      zipMsg.className   = 'field-note';

      fetch('https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + raw)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status === 200 && data.results && data.results.length > 0) {
            const r       = data.results[0];
            const address = r.address1 + r.address2 + r.address3;
            if (addrInput) addrInput.value = address;
            zipMsg.textContent = '住所を入力しました';
            zipMsg.className   = 'field-note match-ok';
          } else {
            zipMsg.textContent = '該当する住所が見つかりませんでした';
            zipMsg.className   = 'field-note match-ng';
          }
        })
        .catch(function () {
          zipMsg.textContent = '住所の取得に失敗しました。手動で入力してください。';
          zipMsg.className   = 'field-note match-ng';
        });
    });
  }

  /* Enterキーで郵便番号検索 */
  if (zipInput) {
    zipInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (zipBtn) zipBtn.click();
      }
    });
  }

});
